import script from "./YamlTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./YamlTab.vue?vue&type=script&setup=true&lang=ts"

import "./YamlTab.vue?vue&type=style&index=0&id=72ab656e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72ab656e"]])

export default __exports__